// 此文件由 json_to_games.py 自动生成
// 生成时间: 2025-03-25 23:38:50

export default {
  "id": "farmer-pedro",
  "slug": "farmer-pedro",
  "publisher": "GoGameVault",
  "thumbnail": "https://img.gamedistribution.com/b73b4f183efd41459b1baba4c4ee08f5-512x384.jpg",
  "gameUrl": "https://html5.gamedistribution.com/b73b4f183efd41459b1baba4c4ee08f5/",
  "releaseDate": "2025-03-25",
  "rating": 4.5,
  "plays": 0,
  "isNew": true,
  "isPopular": false,
  "isRecommended": false,
  "i18n": {
    "en": {
      "title": "Farmer Pedro",
      "description": "Get ready to till the soil and reap the rewards in Farmer Pedro!\n\nIn this charming 3D farming simulator, you’ll take on the role of Pedro, a humble farmer with a big dream - to build the most bountiful farm in the countryside. Start by driving your trusty tractor around the initial plot of land, harvesting a variety of crops like corn, tomatoes, carrots, and more.\n\nAs you grow and harvest your crops, you’ll earn cash that can be used to expand your farmland and unlock access to new crops.",
      "instructions": "Harvest crops and turn them into cash. Grow your farmland.",
      "genres": [
        "Casual",
        "Simulation"
      ],
      "tags": [
        "3d",
        "business",
        "construction",
        "farm",
        "food"
      ]
    },
    "zh-CN": {
      "title": "农民佩德罗",
      "description": "准备好在农夫佩德罗中耕作土地并收获回报！\n\n在这款迷人的3D农场模拟器中，你将扮演佩德罗的角色，一个怀揣大梦想的谦逊农夫——在乡村建设最富饶的农场。首先，驾驶你可靠的拖拉机在初始地块上穿梭，收获各种作物，如玉米、番茄、胡萝卜等。\n\n随着你种植和收获作物，你将赚取现金，这些现金可以用来扩大你的农场，并解锁新的作物。",
      "instructions": "收割农作物，将其转化为现金。拓展你的农场。",
      "genres": [
        "休闲",
        "模拟"
      ],
      "tags": [
        "三维",
        "商业",
        "建筑",
        "农场",
        "食物"
      ]
    },
    "zh-TW": {
      "title": "農夫佩德羅",
      "description": "準備好耕種土地並收穫收穫吧！在這款迷人的3D農場模擬器中，你將扮演佩德羅的角色，他是一位謙遜的農夫，擁有偉大的夢想——在鄉村地區建立最豐收的農場。從駕駛你那可靠的拖拉機在初始的耕地周圍開始，收穫各種作物，如玉米、番茄、胡蘿蔔等。\n\n隨著你種植和收穫作物，你將獲得金錢，可以用來擴展你的農田並解鎖新作物。",
      "instructions": "收穫作物並將其轉換成現金。擴張你的農場。",
      "genres": [
        "休闲",
        "模擬"
      ],
      "tags": [
        "3D",
        "商業",
        "建築",
        "農場",
        "食物"
      ]
    },
    "zh-HK": {
      "title": "農夫佩德羅",
      "description": "準備好耕種土地並收穫收穫吧！在這款迷人的3D農場模擬遊戲中，你將扮演佩德羅，一位懷抱大夢的謙虛農夫 - 想要建立一個鄉村中最豐收的農場。從駕駛你那可靠的拖拉機在初始土地上開始，收穫各種作物，如玉蜀黍、番茄、胡蘿蔔等等。\n\n隨著你種植和收穫作物，你將獲得金錢，可以用來擴展你的農田並解鎖新作物。",
      "instructions": "收穫農作物並將其轉換成現金。擴大你的農田。",
      "genres": [
        "隨意",
        "模擬"
      ],
      "tags": [
        "3D",
        "商業",
        "建築",
        "農場",
        "食物"
      ]
    },
    "ja": {
      "title": "ファーマー・ペドロ",
      "description": "Farmer Pedroで土を耕し、収穫の報酬を得る準備をしよう！\n\nこの魅力的な3D農業シミュレータで、ピドロという地味な農夫の役割を担います。彼の大きな夢は、郊外で最も豊かな農場を作ることです。まず、信頼のトラクターで最初の土地を巡り、トウモロコシ、トマト、ニンジンなど、さまざまな作物を収穫します。\n\n作物を育て、収穫するにつれて、稼いだお金を使って農場を拡張し、新しい作物へのアクセスを解除することができます。",
      "instructions": "作物を収穫し、現金に変える。あなたの農園を育成せよ。",
      "genres": [
        "カジュアル",
        "シミュレーション"
      ],
      "tags": [
        "3D",
        "ビジネス",
        "建設",
        "農場",
        "食料"
      ]
    },
    "ko": {
      "title": "농부 페드로",
      "description": "농부 페드로에서 토양을 갈고 수확을 맛보세요!\n\n이 매력적인 3D 농업 시뮬레이터에서는 페드로라는 평범한 농부의 역할을 맡게 됩니다. 페드로는 큰 꿈을 안고 있습니다 - 마을에서 가장 풍요로운 농장을 건설하는 것입니다. 초반의 토지를 돌아다니며 신뢰할 수 있는 트랙터를 운전하여 콩, 토마토, 양배추 등 다양한 작물을 수확하세요.\n\n작물을 키우고 수확함에 따라 벌 수 있는 돈을 통해 농장을 확장하고 새로운 작물에 접근할 수 있는 권리를 해금할 수 있습니다.",
      "instructions": "콩을 수확하고 현금으로 변환하세요. 농장을 확장하세요.",
      "genres": [
        "캐주얼",
        "시뮬레이션"
      ],
      "tags": [
        "3D",
        "비즈니스",
        "건설",
        "농장",
        "식량"
      ]
    },
    "fr": {
      "title": "Fermeur Pedro",
      "description": "Préparez-vous à cultiver la terre et à récolter les récompenses dans Farmer Pedro !\n\nDans ce charmant simulateur de ferme en 3D, vous prendrez le rôle de Pedro, un paysan humble avec un grand rêve - construire la ferme la plus féconde de la campagne. Commencez par conduire votre fidèle tracteur autour du terrain initial, en récoltant une variété de cultures comme le maïs, les tomates, les carottes et bien d'autres.\n\nÀ mesure que vous cultivez et récoltez vos cultures, vous gagnerez de l'argent que vous pouvez utiliser pour agrandir votre ferme et déverrouiller l'accès à de nouvelles cultures.",
      "instructions": "Récoltez les cultures et transformez-les en argent. Étendez votre ferme.",
      "genres": [
        "Loisir",
        "Simulation"
      ],
      "tags": [
        "3D",
        "entreprise",
        "construction",
        "ferme",
        "nourriture"
      ]
    }
  }
};
